import React, { useRef } from 'react'; 
import './Join.css';


const Join = () => {
  const form = useRef(); 
   const sendEmail = (e) => {
    e.preventDefault(); 
    console.log("Form submitted!");
    e.target.reset(); 
    
  };

  return (
    <div className="Join" id="join-us"> {/* Changed class to "Join" for consistency with CSS */}
      <div className="left-j">
        <hr className="orange-line" /> {/* The small orange line */}
        <div>
          <span className="stroke-text">READY TO</span>
          <span> LEVEL UP</span>
        </div>
        <div>
          <span>YOUR </span>
          <span className="stroke-text">BODY WITH US?</span>
        </div>
      </div>

      <div className="right-j">
        <form ref={form} className="email-container" onSubmit={sendEmail}>
          <input
            type="email"
            name="user_email" // Name attribute for form data
            placeholder="Enter your Email Address here"
            required
          />
          <button type="submit" className="btn join-btn">
            Join now
          </button>
        </form>
      </div>
    </div>
  );
};

export default Join; // Corrected export statement